import { useCallback } from 'react';
import { Outlet, useNavigate, useParams } from 'react-router-dom';
import { BusinessManagementTabs } from '../../ui/business/BusinessManagementTabs/BusinessManagementTabs';
import { DashboardPage } from '../../ui/dashboard/DashboardPage';
import { Typography } from '../../ui/typography/Typography';
import { hasAccessToBusinessStat, isBloggerBusiness } from '../../utils/accessService';
import { ymTrackFeedManagerPostsOpen, ymTrackFeedManagerStaticOpen } from '../../utils/metrika';
import { useTranslation } from '../../utils/useTranslation';
import { useCurrentUser } from '../users/useCurrentUser';
import { withBusinessAuthProtection } from '../withBusinessAuthProtection';
import { useBusinessModel } from './useBusinessModel';

export const BusinessManagement = withBusinessAuthProtection(() => {
    const t = useTranslation();
    const navigate = useNavigate();
    const { businessId } = useParams();
    const business = useBusinessModel({ businessId: businessId! });
    const currentUser = useCurrentUser();
    const hasAccess = hasAccessToBusinessStat(businessId, currentUser);
    const accountPrefix = isBloggerBusiness(business?.type) ? 'profile' : 'businesses';

    const tabs = [
        {
            value: `/${accountPrefix}/${businessId}/management`,
            label: t('Управление контентом'),
        },
        {
            value: `/${accountPrefix}/${businessId}/management/statistic`,
            label: t('Сводка'),
        },
    ];

    const onTabClick = useCallback(
        (value: string) => {
            if (value === `/${accountPrefix}/${businessId}/management`) {
                ymTrackFeedManagerPostsOpen({
                    page: 'Управления постами',
                    userLogin: currentUser?.login,
                    businessId: currentUser?.profile?.publicId,
                });
            }
            if (value === `/${accountPrefix}/${businessId}/management/statistic`) {
                ymTrackFeedManagerStaticOpen({
                    page: 'Управления постами',
                    userLogin: currentUser?.login,
                    businessId: currentUser?.profile?.publicId,
                });
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [currentUser?.login, currentUser?.profile?.publicId],
    );

    if (!hasAccess) {
        navigate('/');
    }

    return (
        <DashboardPage key={businessId} pb={0} pr={{ sm: 3 }} maxWidth="100%" centered={false}>
            <Typography variant="title2" weight="bold" my={2} ml={{ xs: 2, sm: 0 }}>
                {t('Управление лентой')}
            </Typography>
            <BusinessManagementTabs tabs={tabs} onTabClick={onTabClick} />
            <Outlet />
        </DashboardPage>
    );
});
